export const getNurseType = (nurseType) => {
  return nurseType === "INPATIENT_NURSE" ? "nội trú" : "phòng khám";
};
